import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { ResourceManagementCreation } from '../Components/Dashboard/ResourceManagementCreation';
import { UserManagementContent } from '../Components/Dashboard/UserManagementContent';
import { UserManagementCreationMultiple } from '../Components/Dashboard/UserManagementCreationMultiple';
import { UserManagementModification } from '../Components/Dashboard/UserManagementModification';
import { Layout } from '../Components/Layout';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import {
	hideDrawer,
	setDrawerContent,
	setPageContent,
	showDrawer,
} from '../Store/Layout/Actions';
import { IUserState } from '../Store/User/Types';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	user: IUserState;
	router: RouteComponentProps<IRouterMatchParams>;
}

interface IPropsFromDispatch {
	setDrawerContent: typeof setDrawerContent;
	setPageContent: typeof setPageContent;
	showDrawer: typeof showDrawer;
	hideDrawer: typeof hideDrawer;
}

type AllProps = IPropsFromDispatch &
	IPropsFromState &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class UserManagementPage extends React.Component<AllProps> {
	componentDidMount() {
		this.props.showDrawer();

		switch (this.props.router.match.params.type) {
			case 'creation':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={UserManagementCreationMultiple} />
				);
				break;
			case 'modify':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={UserManagementModification} />
				);
				break;
			case 'resource-creation':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={ResourceManagementCreation} />
				);
				break;
			default:
				this.props.showDrawer();
				this.props.setPageContent(
					<Route component={UserManagementContent} />
				);
				break;
		}
	}
	componentDidUpdate() {
		this.props.showDrawer();

		switch (this.props.router.match.params.type) {
			case 'creation':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={UserManagementCreationMultiple} />
				);
				break;
			case 'modify':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={UserManagementModification} />
				);
				break;
			case 'resource-creation':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={ResourceManagementCreation} />
				);
				break;
			default:
				this.props.showDrawer();
				this.props.setPageContent(
					<Route component={UserManagementContent} />
				);
				break;
		}
	}
	public render(): React.ReactNode {
		return <Route component={Layout} />;
	}
}

const mapStateToProps = (
	state: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	router: ownProps,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
	setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
	showDrawer: () => dispatch(showDrawer()),
	hideDrawer: () => dispatch(hideDrawer()),
});

export const UserManagement = connect(
	mapStateToProps,
	mapDispatchToProps
)(UserManagementPage);
